import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const ANNOUNCEMENT_BASE_URL =
  `${API_BASE_URL}/announcements`;

// ==========================
// GET ANNOUNCEMENTS
// ==========================
export const getAnnouncementsApi = async (
  params: {
    client_id?: number | string;
    user_id?: number | string;
    page?: number;
    limit?: number;
  },
  signal?: AbortSignal
) => {
  try {
    const res = await axios.get(
      ANNOUNCEMENT_BASE_URL,
      {
        params,
        signal,
      }
    );

    return res.data;
  } catch (error: any) {
    if (
      error?.name === "CanceledError" ||
      error?.code === "ERR_CANCELED"
    ) {
      throw error;
    }

    return {
      success: false,
      status: false,
      data: [],
      message:
        error?.response?.data?.message ||
        "Unable to fetch announcements",
    };
  }
};
